import { twMerge } from "tailwind-merge";

export function SelectionOrderBadge({
  className,
  order,
}: {
  className?: string;
  order: number;
}) {
  return (
    <span
      aria-label={`Selected, position ${order}`}
      className={twMerge(
        "flex size-5 shrink-0 items-center justify-center rounded-full bg-bg-brand-solid text-xs font-semibold text-text-white",
        className,
      )}
    >
      {order}
    </span>
  );
}
